export const LeaseRegWrapper = data => {
    var reg1 = /(.+)租$/;
    return data.concat( reg1 );
}
